"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ButtonLink = exports.Button = exports.ButtonCSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        border-bottom: 3px solid ", ";\n        color: white;\n        &:hover {\n          background: ", ";\n          border: 1px solid ", ";\n        }\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n        path {\n          fill: ", ";\n        }\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        border-bottom: 3px solid ", ";\n        color: white;\n        &:hover {\n          background: ", ";\n          border: 1px solid ", ";\n        }\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n        path {\n          fill: ", ";\n        }\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        border-bottom: 3px solid ", ";\n        color: white;\n        &:hover {\n          background: ", ";\n          border: 1px solid ", ";\n        }\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n        path {\n          fill: ", ";\n        }\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n        border: 1px solid ", ";\n        border-bottom: 3px solid ", ";\n        color: ", ";\n        &:hover {\n          background: ", ";\n          border: 1px solid ", ";\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        opacity: 0.5;\n        cursor: not-allowed;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      &:hover {\n        background: ", "\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n        path {\n          fill: ", ";\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background: ", ";\n  border: 1px solid ", ";\n  border-bottom: 3px solid ", ";\n  color: ", ";\n  path {\n    fill: ", ";\n  }\n  border-radius: 4px;\n  text-decoration: none;\n  justify-content: center;\n  text-align: center;\n  transition: 0.1s color;\n  cursor: pointer;\n  svg {\n    position: relative;\n    top: 2px;\n    right: 3px;\n    max-height: 18px;\n  }\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ButtonCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.theme.colors.brand['500'];
}, function (props) {
  return props.theme.colors.brand['500'];
}, function (props) {
  return props.theme.colors.brand['300'];
}, function (props) {
  return props.theme.colors.white['900'];
}, function (props) {
  return props.theme.colors.white['900'];
}, function (props) {
  return props.width ? "min-width: ".concat(props.width, ";") : '';
}, function (props) {
  if (props.size === 'xs') {
    return "\n        padding: .3em .6em;\n        font-size: 0.8em;\n        svg {\n          height: 0.8em;\n          width: 0.8em;\n        }\n      ";
  }

  if (props.size === 'sm') {
    return "\n        padding: 0.5em 1em;\n        font-size: 0.8em;\n        svg {\n          height: 0.8em;\n          width: 0.8em;\n        }\n      ";
  }

  if (props.size === 'md' || !props.size) {
    return "\n        padding: 0.6em 1.2em;\n        font-size: 1em;\n        svg {\n          height: 1em;\n          width: 1em;\n        }\n      ";
  }

  if (props.size === 'lg') {
    return "\n        padding: 0.8em 1.4em;\n        font-size: 1.4em;\n        svg {\n          height: 1.2em;\n          width: 1.2em;\n          margin-left: 0.5em;\n        }\n      ";
  }

  if (props.size === 'xl') {
    return "\n        width: 100%;\n        padding: 1em 2em;\n        font-size: 1.6em;\n        text-align: center;\n        svg {\n          height: 1.2em;\n          width: 1.2em;\n          margin: 0 0.25em;\n        }\n      ";
  }

  return "\n      padding: 0.6em 1.2em;\n      font-size: 1.1em;\n    ";
}, function (props) {
  if (props.inverted) {
    return (0, _styledComponents.css)(_templateObject2(), props.theme.colors.brand['500'], props.theme.colors.brand['500'], function (props) {
      return props.theme.colors.brand['500'];
    });
  }

  return (0, _styledComponents.css)(_templateObject3(), function (props) {
    return props.theme.colors.brand['300'];
  });
}, function (props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject4());
  }
}, function (props) {
  if (props.buttonType === 'white' && props.inverted) {
    return (0, _styledComponents.css)(_templateObject5(), props.theme.colors.white['900'], props.theme.colors.white['900']);
  }

  if (props.buttonType === 'white' && !props.inverted) {
    return (0, _styledComponents.css)(_templateObject6(), props.theme.colors.white['900'], props.theme.colors.white['300'], props.theme.colors.white['300'], props.theme.colors.brand['500'], props.theme.colors.white['300'], props.theme.colors.white['300']);
  }

  if (props.buttonType === 'warning' && props.inverted) {
    return (0, _styledComponents.css)(_templateObject7(), props.theme.colors.red['500'], props.theme.colors.red['500'], function (props) {
      return props.theme.colors.red['500'];
    });
  }

  if (props.buttonType === 'warning' && !props.inverted) {
    return (0, _styledComponents.css)(_templateObject8(), props.theme.colors.red['500'], props.theme.colors.red['500'], props.theme.colors.red['300'], props.theme.colors.red['300'], props.theme.colors.red['300']);
  }

  if (props.buttonType === 'success' && props.inverted) {
    return (0, _styledComponents.css)(_templateObject9(), props.theme.colors.green['500'], props.theme.colors.green['500'], function (props) {
      return props.theme.colors.green['500'];
    });
  }

  if (props.buttonType === 'success' && !props.inverted) {
    return (0, _styledComponents.css)(_templateObject10(), props.theme.colors.green['500'], props.theme.colors.green['500'], props.theme.colors.green['300'], props.theme.colors.green['300'], props.theme.colors.green['300']);
  }

  if (props.buttonType === 'default' && props.inverted) {
    return (0, _styledComponents.css)(_templateObject11(), props.theme.colors.gray['900'], props.theme.colors.gray['500'], function (props) {
      return props.theme.colors.gray['500'];
    });
  }

  if (props.buttonType === 'default' && !props.inverted) {
    return (0, _styledComponents.css)(_templateObject12(), props.theme.colors.gray['900'], props.theme.colors.gray['900'], props.theme.colors.gray['700'], props.theme.colors.gray['700'], props.theme.colors.gray['700']);
  }
});
exports.ButtonCSS = ButtonCSS;

var Button = _styledComponents["default"].button(_templateObject13(), ButtonCSS);

exports.Button = Button;

var ButtonLink = _styledComponents["default"].a(_templateObject14(), ButtonCSS);

exports.ButtonLink = ButtonLink;
var _default = Button;
exports["default"] = _default;